module.exports = __webpack_public_path__ + "img/3.6de4e48a.png";